import { useEffect } from 'react'

import { Table } from '@skytech/ui'
import { useDispatch, useSelector } from 'react-redux'

import { Translation } from '@/components/i18n/Translation'
import Error from '@/components/util/feedback/Error'
import ListLoader from '@/components/util/ListLoader'
import LoaderCircle from '@/components/util/LoaderCircle'
import NoResults from '@/components/util/NoResults'
import {
  fetchDeviceOrders,
  getError,
  getIsDataLoaded,
  getIsPending,
  getOrderListExceedsLimit,
  getVisibleOrders,
  increaseListRenderLimit,
} from '@/ducks/deviceOrdersReducer'

import DeviceOrderListItem from './DeviceOrderListItem'

import './device-order-list.scss'

const DeviceOrderList = () => {
  const dispatch = useDispatch()

  const error = useSelector(getError)
  const isPending = useSelector(getIsPending)
  const iIsDataLoaded = useSelector(getIsDataLoaded)

  const orders = useSelector(getVisibleOrders)

  useEffect(() => {
    // @ts-ignore
    dispatch(fetchDeviceOrders())
  }, [])

  return (
    <>
      {error && <Error textId={error} />}

      {isPending && !iIsDataLoaded ? (
        <LoaderCircle />
      ) : (
        <>
          <Table rowHeight="tall" className="device-order-list">
            {orders.length > 0 && (
              <thead>
                <tr>
                  <th className="center">
                    <Translation id="id" />
                  </th>
                  <th>
                    <Translation id="user" />
                  </th>
                  <th>
                    <Translation id="status" />
                  </th>
                  <th>
                    <Translation id="payments" />
                  </th>
                  <th>
                    <Translation id="cost" />
                  </th>
                  <th>
                    <Translation id="order date" />
                  </th>
                  <th>
                    <Translation id="delivery date" />
                  </th>
                </tr>
              </thead>
            )}

            <tbody>
              {orders.map(order => (
                <DeviceOrderListItem key={order.id} {...order} />
              ))}
            </tbody>
          </Table>

          {orders.length === 0 && <NoResults />}

          <ListLoader
            // @ts-ignore
            conditionSelector={getOrderListExceedsLimit}
            action={() => dispatch(increaseListRenderLimit())}
          />
        </>
      )}
    </>
  )
}

export default DeviceOrderList
